/** @type {import('../help-index.js').HelpSidebarItem} */
export const ACC_CFG_DEFAULTS_ITEM = {
  id: 'defaults',
  screenId: 'acc-cfg-defaults',
  label: 'Cuentas default',
  description: 'Cuentas por defecto cuando no hay asignación específica.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Cuando un cliente, proveedor, artículo o movimiento no tiene cuenta propia, el sistema usa estas cuentas al contabilizar.',
      },
      {
        title: 'Campos principales',
        fields: [
          { label: 'Moneda funcional', description: 'Moneda de referencia de la contabilidad (ej. ARS).' },
          { label: 'Clientes / Proveedores', description: 'Cuentas de deudores y acreedores por defecto.' },
          { label: 'Caja / Ventas / Compras', description: 'Operaciones habituales sin mapeo fino.' },
          { label: 'IVA débito y crédito fiscal', description: 'Impuesto en ventas y compras.' },
          { label: 'Percepciones (IIBB, IVA, nacionales, municipales)', description: 'Agente y sufridas.' },
          { label: 'Cheques, cobros/pagos adelantados', description: 'Instrumentos y anticipos.' },
          { label: 'Resultados acumulados, diferencias de cambio, redondeos, ajuste RT 6', description: 'Cierre y ajustes.' },
        ],
        paragraphs: ['Tocá «Guardar configuración» al final de la sección.'],
      },
    ],
  },
}
